import React, { useState } from 'react';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';

// Mapeamento de Fornecedor para Operadora
const OPERADORA_MAP = {
  'SulAmérica Saúde': 'SULAMÉRICA (182)',
  'AMIL SAÚDE SA': 'AMIL (167)',
  'AMPLA': 'AMPLA SAÚDE (247)',
  'SEGUROS UNIMED': 'UNIMED SEGUROS (229)',
  'NOTRE DAME (LINHA INTERMÉDICA)': 'HAPVIDA NOTREDAME (169)',
  'CNU': 'CENTRAL NACIONAL UNIMED (192)',
  'São Cristóvão': 'SÃO CRISTOVÃO (197)',
  'Unimed Santos': 'UNIMED SANTOS (255)',
  'BLUE': 'BLUE (261)'
};

const ConversorQUALI = () => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [previewData, setPreviewData] = useState(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setError('');
      setSuccess(false);
      setPreviewData(null);
    }
  };

  const processFile = async () => {
    if (!file) {
      setError('Por favor, selecione um arquivo para converter.');
      return;
    }
    setLoading(true);
    setError('');
    setSuccess(false);
    try {
      const fileContent = await readFileAsText(file);
      Papa.parse(fileContent, {
        header: true,
        delimiter: ';',
        encoding: 'CP1252',
        skipEmptyLines: true,
        dynamicTyping: false,
        complete: function(results) {
          if (results.errors.length > 0) {
            setError(`Erro ao processar o CSV: ${results.errors[0].message}`);
            setLoading(false);
            return;
          }
          const transformedData = transformData(results.data);
          setPreviewData(transformedData.slice(0, 5));
          generateExcel(transformedData);
          setSuccess(true);
          setLoading(false);
        },
        error: function(error) {
          setError(`Erro ao processar o arquivo: ${error.message}`);
          setLoading(false);
        }
      });
    } catch (err) {
      setError(`Erro ao ler o arquivo: ${err.message}`);
      setLoading(false);
    }
  };

  const readFileAsText = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target.result);
      reader.onerror = (e) => reject(e.target.error);
      reader.readAsText(file, 'CP1252');
    });
  };

  // Função principal de transformação
  const transformData = (data) => {
    // Agrupar por Número Proposta
    const grupos = {};
    data.forEach(row => {
      const proposta = row['Número Proposta'];
      if (!proposta) return;
      if (!grupos[proposta]) {
        grupos[proposta] = {
          proposta,
          valorProposta: 0,
          valorComissao: 0,
          parcela: row['Parcelas'],
          fornecedor: row['Fornecedor'],
          beneficiarios: [],
        };
      }
      // Somar valores
      const valorProp = parseFloat((row['Valor Proposta'] || '0').replace('.', '').replace(',', '.')) || 0;
      const valorCom = parseFloat((row['Valor Comissão'] || '0').replace('.', '').replace(',', '.')) || 0;
      grupos[proposta].valorProposta += valorProp;
      grupos[proposta].valorComissao += valorCom;
      // Guardar beneficiários
      grupos[proposta].beneficiarios.push({
        nome: row['Beneficiário'],
        parentesco: row['Parentesco']
      });
    });
    // Data atual
    const hoje = new Date();
    const dataAtual = `${String(hoje.getDate()).padStart(2, '0')}/${String(hoje.getMonth() + 1).padStart(2, '0')}/${String(hoje.getFullYear()).slice(-2)}`;
    // Montar resultado
    const resultado = Object.values(grupos).map(grupo => {
      const titular = grupo.beneficiarios.find(b => b.parentesco && b.parentesco.toUpperCase() === 'TITULAR');
      return {
        'Data_atual': dataAtual,
        'Administradora': 'QUALICORP (61)',
        'Operadora': OPERADORA_MAP[grupo.fornecedor] || grupo.fornecedor || '',
        'Tipo': 'pf',
        'Modalidade': 'ADESÃO SAÚDE (160)',
        'Proposta': grupo.proposta,
        'Nome': titular ? titular.nome : '',
        'Saude/Dental': 's',
        'parcela': grupo.parcela,
        'Base Calculo': grupo.valorProposta,
        'Base Calculo_2': grupo.valorProposta,
        'Comissão': grupo.valorComissao,
        'Recibo': 10
      };
    });
    return resultado;
  };

  const generateExcel = (data) => {
    try {
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados Formatados');
      const excelBuffer = XLSX.write(workbook, { bookType: 'xls', type: 'array' });
      const blob = new Blob([excelBuffer], { type: 'application/vnd.ms-excel' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Qualicorp_Formatado.xls';
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, 0);
    } catch (err) {
      setError(`Erro ao gerar o arquivo Excel: ${err.message}`);
    }
  };

  return (
    <div className="container">
      <h1>Conversor Qualicorp para Excel</h1>
      <div className="upload-section">
        <div className="file-input">
          <label>
            Selecione o arquivo CSV:
            <input
              type="file"
              accept=".csv"
              onChange={handleFileChange}
            />
          </label>
        </div>
        <div className="button-group">
          <button
            onClick={processFile}
            disabled={loading || !file}
            className={loading || !file ? 'button-disabled' : 'button'}
          >
            {loading ? 'Processando...' : 'Converter para Excel'}
          </button>
        </div>
      </div>
      {error && (
        <div className="error-message">{error}</div>
      )}
      {success && (
        <div className="success-message">
          Arquivo processado com sucesso! O download começará automaticamente.
        </div>
      )}
      {previewData && previewData.length > 0 && (
        <div className="preview-section">
          <h2>Prévia dos dados convertidos (Qualicorp):</h2>
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  {Object.keys(previewData[0]).map((key, index) => (
                    <th key={index}>{key}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {previewData.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {Object.values(row).map((value, valueIndex) => (
                      <td key={valueIndex}>{value}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      <div className="info-section">
        <h3>Sobre o Processamento:</h3>
        <ul>
          <li>Agrupa os dados por Número Proposta</li>
          <li>Soma Valor Proposta e Valor Comissão para cada grupo</li>
          <li>Extrai o titular do grupo</li>
          <li>Mapeia a Operadora conforme a coluna Fornecedor</li>
          <li>Gera o Excel no padrão solicitado</li>
        </ul>
      </div>
    </div>
  );
};

export default ConversorQUALI; 